import { useParams, useSearchParams } from "react-router-dom";
import { useSelector } from "src/redux/hooks";
/**
 * Determines if the current entry is a new entry based on URL parameters and state.
 *
 * @param includeOfflineEntry - A boolean indicating whether to include offline entries in the check. Defaults to true.
 * @returns A boolean indicating whether the current entry is new.
 */
export const useIsNewEntry = (includeOfflineEntry = true): boolean => {
  const id = useSelector(state => state.generatorSlice.latestEntry.id);
  const pendingNewEntries = useSelector(
    state => state.pendingRequestsSlice.pendingNewEntries,
  );
  const [searchParams] = useSearchParams();
  const { lbeidOrPartId } = useParams();

  const isNewParam = searchParams.get("new") === "true";
  const isNewId = id === "new";

  if (
    !isNewParam &&
    lbeidOrPartId &&
    lbeidOrPartId !== "new" &&
    id &&
    id !== "new" &&
    lbeidOrPartId === id
  ) {
    return false;
  }

  const isOfflinePattern =
    typeof lbeidOrPartId === "string" &&
    lbeidOrPartId.includes("new=") &&
    lbeidOrPartId.includes("lbid=");

  const isSavedOfflineEntry = pendingNewEntries.some(
    entry => entry.id === lbeidOrPartId,
  );

  if (includeOfflineEntry) {
    return isNewParam || isNewId || (isOfflinePattern && !isSavedOfflineEntry);
  }

  return isNewParam || isNewId;
};
